export * from '../src/layout/wui-separator/index.js';
//# sourceMappingURL=wui-separator.js.map